export const PROCESS_DIAGRAM_DEFAULT_SOURCE_HANDLE = 'default';
export const PROCESS_DIAGRAM_TARGET_HANDLE = 'target';

const ANSWER_HANDLE_PREFIX = 'answer-';

export const answerSourceHandleId = (answerKey: number): string => `${ANSWER_HANDLE_PREFIX}${answerKey}`;

export const parseSourceHandleAnswerKey = (handleId: string | null | undefined): number | null => {
    if (!handleId || handleId === PROCESS_DIAGRAM_DEFAULT_SOURCE_HANDLE) return null;
    if (!handleId.startsWith(ANSWER_HANDLE_PREFIX)) return null;
    const key = Number(handleId.slice(ANSWER_HANDLE_PREFIX.length));
    return Number.isFinite(key) ? key : null;
};

export const sourceHandleIdFromAnswerKey = (answerKey: number | null): string =>
    answerKey == null ? PROCESS_DIAGRAM_DEFAULT_SOURCE_HANDLE : answerSourceHandleId(answerKey);
